import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const calendarDefaultVariants = {}
const calendarCompoundVariants = []

const calendarSlotNames = [
  [
    "root",
    "Calendar__root"
  ],
  [
    "header",
    "Calendar__header"
  ],
  [
    "wrapper",
    "Calendar__wrapper"
  ],
  [
    "month",
    "Calendar__month"
  ],
  [
    "days",
    "Calendar__days"
  ],
  [
    "day",
    "Calendar__day"
  ],
  [
    "row",
    "Calendar__row"
  ],
  [
    "dateButton",
    "Calendar__dateButton"
  ]
]
const calendarSlotFns = /* @__PURE__ */ calendarSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, calendarDefaultVariants, getSlotCompoundVariant(calendarCompoundVariants, slotName))])

const calendarFn = memo((props = {}) => {
  return Object.fromEntries(calendarSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const calendarVariantKeys = [
  "isInitialized",
  "isToday",
  "isActive"
]
const getVariantProps = (variants) => ({ ...calendarDefaultVariants, ...compact(variants) })

export const calendar = /* @__PURE__ */ Object.assign(calendarFn, {
  __recipe__: false,
  __name__: 'calendar',
  raw: (props) => props,
  variantKeys: calendarVariantKeys,
  variantMap: {
  "isInitialized": [
    "true",
    "false"
  ],
  "isToday": [
    "true"
  ],
  "isActive": [
    "true"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, calendarVariantKeys)
  },
  getVariantProps
})